/*
 MappingField.js component
 url match: none
 Helper component to display fields in OutputMapping component table
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { templateStyles } from '../../Styles/templateStyles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import MenuIcon from '@material-ui/icons/Menu';
import Checkbox from '@material-ui/core/Checkbox';

@inject('templateStore')
@observer
class MappingField extends React.Component {

    handleChange = (event, index, value) => {
        this.props.templateStore.updateMappingValue(index, value)
    }

    onCheckboxChange = (event, index, value) => {
        this.props.templateStore.updateRequiredMappings(index, value)
        this.props.updateSelectAll(value)
    }

    render() {
        const { classes, row, index } = this.props;
        return (
            <Table style={{ width: '95%' }}>
                <TableRow>
                    <TableCell className={classes.tableData} style={{ width: '14vw' }} align="left"><div className="rowFlex"><MenuIcon fontSize="small" className={classes.menuIcon} />{index + 1}</div></TableCell>
                    <TableCell className={classes.tableData} style={{ width: '22vw' }} align="left" >{row.aiLabel}</TableCell>
                    <TableCell className={classes.tableData} style={{ width: '21vw' }} align="left">{row.aiValue}</TableCell>
                    <TableCell className={classes.tableData} style={{ width: '23vw' }} align="left">
                        <TextField style={{ paddingTop: 0, marginTop: '8px' }}
                            required
                            placeholder="Label"
                            type="text"
                            name="name"
                            autoComplete="name"
                            margin="normal"
                            variant="filled"
                            fullWidth
                            InputProps={{
                                disableUnderline: true,
                                classes: {
                                    input: classes.textFieldInput
                                },

                            }}
                            value={row.editedLabel}
                            onChange={(event) => this.handleChange(event, index, event.target.value)}

                        />
                    </TableCell>
                    <TableCell className={classes.tableData} style={{ width: '15vw' }} align="left">
                        <Checkbox className={classes.checkbox}
                            style={{ marginLeft: '54px' }}
                            checked={row.isOutputMappingRequired}
                            onChange={(event, value) => this.onCheckboxChange(event, index, value)}
                            color="primary"
                            inputProps={{ classes: { root: classes.checkbox } }} />
                    </TableCell>
                </TableRow>
            </Table>
        )

    }
}
export default withStyles(templateStyles, { withTheme: true })(withRouter(MappingField));


